module.exports = __webpack_public_path__ + "static/media/stanton.2a9f70f8.png";